import { render, staticRenderFns } from "./SignUpBusiness.vue?vue&type=template&id=7d529b6c&"
import script from "./SignUpBusiness.vue?vue&type=script&lang=js&"
export * from "./SignUpBusiness.vue?vue&type=script&lang=js&"
import style0 from "./SignUpBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports